import { useEffect, useState } from 'react';

export function useVercelOverrides() {
  const [overrides, setOverrides] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const fetchOverrides = async () => {
      try {
        const cookie =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('vercel-flag-overrides='))
            ?.split('=')[1] ?? '';

        const response = await fetch('/.well-known/vercel/flags/decode', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            encryptedValue: cookie
          })
        });

        if (!response.ok) return;

        const data = (await response.json()) as Record<string, boolean>;
        setOverrides(data);
      } catch (error) {
        console.error('Failed to fetch Vercel overrides:', error);
      }
    };

    void fetchOverrides();
  }, []);

  return overrides;
}
